import type { ProcessedCourse } from "@/common/course/types";
import PromoBanner from "@/components/PromoBanner";
import type { PromoBannerVariant } from "@/components/PromoBanner/types";
import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";
import MonarchResolver from "@/monarch/MonarchResolver";
import type { ProgramPromoBannerTestResult } from "@/monarch/rules/programPromoBanner/types";
import { Program } from "@/common/program/types";
import ProgramEnrollButton from "../ProgramEnrollButton";

type ProgramPromoBannerProps = {
  courses: ProcessedCourse[];
  programData: Program;
  skus: string[];
};

type ComponentProps = ProgramPromoBannerProps & {
  variant: PromoBannerVariant;
};

function Component({ courses, programData, skus, variant }: ComponentProps) {
  return (
    <MonarchDataConsumer<ProgramPromoBannerTestResult>
      experimentKey="useProgramPromoBanner"
      render={(testResult) => {
        const { data } = testResult;
        if (!data) {
          return null;
        }
        return (
          <PromoBanner
            ctaElement={
              <ProgramEnrollButton
                courses={courses}
                programData={programData}
                skus={skus}
                buttonClass="w-full md:w-auto mb-4"
                enableTracking={true}
              />
            }
            description={data.description}
            discount={data.discount}
            discountCode={data.discountCode}
            endDate={data.endDate}
            endDatePrefix={data.endDatePrefix}
            image={data.image}
            learnMoreLink={data.learnMoreLink}
            title={data.title}
            variant={variant}
          />
        );
      }}
    />
  );
}

export default function ProgramPromoBanner(props: ProgramPromoBannerProps) {
  return (
    <MonarchResolver<ProgramPromoBannerTestResult>
      experimentKey="useProgramPromoBanner"
      variants={{
        control: null,
        programPromoBannerVariantA: <Component {...props} variant="slim" />,
      }}
      fallbackVariant="control"
    />
  );
}
